import React, {Component} from 'react';
import '../assets/css/Home.css';

class AboutUs extends Component {
    render() {
        return (
            <div className="container partner-list">
                <h1 className="heading">About Us</h1>
                <hr/>
                <h2>Who We Are</h2>
                <p>
                    Shopping for spare parts for vehicles, specially classic cars on a busy schedule is a very stressful
                    and a time consuming job. This is due to having to visit multiple shops in search for the exact part
                    needed and travelling to those shops can take a lot of time and energy. <br/><br/>
                    <strong>Not anymore with Volkslanka!</strong> <br/><br/>
                    Volkslanka is <strong>Sri Lanka's first dedicated</strong> service provider focused mainly on
                    vintage Volkswagens, helping local spare parts shops to reach out to customers without having them
                    to visit the shop.
                </p>
                <br/><br/>
                <h2>What We Do</h2>
                <p>
                    We provide an online platform for partnered spare part shops to list their products on the platform.
                    Customers can place their orders on the platform and get the products delivered to their door steps.
                    <br/><br/>
                    We provide you the ability to purchase Volkswagen spare parts from the comfort at your home.
                </p>
            </div>
        );
    }
}

export default AboutUs;